import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { downloadDocumentMedia } from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';

const MediaDownload = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const startedRef = useRef(false);
    const [status, setStatus] = useState('loading');
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        if (!id || startedRef.current) {
            return;
        }

        startedRef.current = true;

        downloadDocumentMedia(id)
            .then(() => setStatus('success'))
            .catch((err) => {
                setStatus('error');
                setErrorMessage(err?.message || t('Unable to download file.'));
            });
    }, [id, t]);

    if (status === 'loading') {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, p: 4 }}>
                <CircularProgress />
                <Typography>{t('Download in progress...')}</Typography>
            </Box>
        );
    }

    if (status === 'error') {
        return (
            <Box sx={{ p: 4 }}>
                <Typography color="danger">{errorMessage}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 4 }}>
            <Typography>{t('Download started. You can close this page.')}</Typography>
        </Box>
    );
};

export default MediaDownload;
